/**
 * Lazy load Images
 *
 * Used in the image block
 *
 * @version 1.0.0
 * @author Arslan Akram <arslan@pixelative.co>
 * @copyright 2021, Pixelative <pixelative.co>
 */

import LazyLoad from 'vanilla-lazyload';
import LocomotiveScroll from 'locomotive-scroll';
document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    var peScroll = new LocomotiveScroll({
      el: document.querySelector('body'),
      smooth: false
    });
    window.peScroll = peScroll;
    const l1 = new LazyLoad({
      class_applied: 'lz-applied',
      class_loading: 'lz-loading',
      class_loaded: 'lz-loaded',
      class_error: 'lz-error',
      class_entered: 'lz-entered',
      class_exited: 'lz-exited',
      elements_selector: '.lazy',
      callback_loaded: el => {
        // console.log('Image loaded:', el);
        peScroll.update();
      }
    });
  }, 400);
});